export class Organization {
    public acceptReady = null;
    public accountType = null;
    public applePayVerified = null;
    public acceptType = null;
    public bannerBkColor = null;
    public bannerTextColor = null;
    public corpMatchAll = null;
    public corpMatchEnabled = null;
    public coverFeeSetting = null;
    public desc = null;
    public donationLimit = null;
    public email = null;
    public eventList = null;
    public events = null;
    public fixedAchFee = null;
    public fixedCardFee = null;
    public genericTextingEnabled = null;
    public handle = null;
    public id = null;
    public image = null;
    public imageUrl = null;
    public industryType = null;
    public logoUrl = null;
    public name = null;
    public payBeeFee = null;
    public payBeeStreamingEnabled = null;
    public percentAchFee = null;
    public percentCardFee = null;
    public preSwipeEnabled = null;
    public purpose = null;
    public selectedCampaign = null;
    public showNetworkForGoodImport = null;
    public showParishSoftImport = null;
    public status = null;
    public url = null;
    public verificationStatus = null;
    public volunteerSignatureNeeded = null;
    public wallDisplayGoal = null;
    public wallDisplayName = null;

    constructor(organization) {
        if(organization === null) {
            return;
        }
        
        this.acceptReady = organization.acceptReady;
        this.accountType = organization.accountType;
        this.applePayVerified = organization.applePayVerified;
        this.acceptType = organization.acceptType;
        this.bannerBkColor = organization.bannerBkColor;
        this.bannerTextColor = organization.bannerTextColor;
        this.corpMatchAll = organization.corpMatchAll;
        this.corpMatchEnabled = organization.corpMatchEnabled;
        this.coverFeeSetting = organization.coverFeeSetting;
        this.desc = organization.desc;
        this.donationLimit = organization.donationLimit;
        this.email = organization.email;
        this.eventList = organization.eventList;
        this.events = organization.events;
        this.fixedAchFee = organization.fixedAchFee;
        this.fixedCardFee = organization.fixedCardFee;
        this.genericTextingEnabled = organization.genericTextingEnabled;
        this.handle = organization.handle;
        this.id = organization.id;
        this.image = organization.image;
        this.imageUrl = organization.imageUrl;
        this.industryType = organization.industryType;
        this.logoUrl = organization.logoUrl || '/images/grey_1x1.png';
        this.name = organization.name;
        this.payBeeFee = organization.payBeeFee;
        this.payBeeStreamingEnabled = organization.payBeeStreamingEnabled;
        this.percentAchFee = organization.percentAchFee;
        this.percentCardFee = organization.percentCardFee;
        this.preSwipeEnabled = organization.preSwipeEnabled;
        this.purpose = organization.purpose;
        this.selectedCampaign = organization.selectedCampaign;
        this.showNetworkForGoodImport = organization.showNetworkForGoodImport;
        this.showParishSoftImport = organization.showParishSoftImport;
        this.status = organization.status;
        this.url = organization.url;
        this.verificationStatus = organization.verificationStatus;
        this.volunteerSignatureNeeded = organization.volunteerSignatureNeeded;
        this.wallDisplayGoal = organization.wallDisplayGoal;
        this.wallDisplayName = organization.wallDisplayName;
    }
}